import type { FC, SVGProps } from 'react';

const MoonOutlinedIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.25026 0.243516C5.40969 0.437881 5.46411 0.730809 5.32061 0.994111C4.83009 1.89415 4.55132 2.92514 4.55132 4.02225C4.55132 7.54013 7.42026 10.3886 10.9551 10.3886C11.4157 10.3886 11.8645 10.3403 12.2967 10.2488C12.5923 10.1862 12.8611 10.3198 13.0052 10.525C13.1539 10.7368 13.1851 11.0528 12.9779 11.3071C11.6404 12.9487 9.59418 14 7.30062 14C3.26674 14 0 10.7506 0 6.74627C0 3.73258 1.84988 1.14797 4.4831 0.0525768C4.78733 -0.0739823 5.08575 0.0429565 5.25026 0.243516ZM4.25073 1.14681C2.25313 2.2245 0.896798 4.32783 0.896798 6.74627C0.896798 10.2642 3.76574 13.1126 7.30062 13.1126C9.08211 13.1126 10.6939 12.3898 11.8555 11.2213C11.5603 11.2574 11.2598 11.276 10.9551 11.276C6.92126 11.276 3.65452 8.02654 3.65452 4.02225C3.65452 3.00138 3.86702 2.02889 4.25073 1.14681Z"
        fill="white"
      />
    </svg>
  );
};

export default MoonOutlinedIcon;
